function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 0A1.5 1.5 0 0116 1.5v2a1.5 1.5 0 01-1 1.414V12.5a3.5 3.5 0 01-3.5 3.5h-7A3.5 3.5 0 011 12.5V4.915A1.5 1.5 0 010 3.5v-2A1.5 1.5 0 011.5 0h13zM14 5H2v7.5A2.5 2.5 0 004.5 15h7a2.5 2.5 0 002.5-2.5V5zM6.5 7h3a.5.5 0 01.09.992L9.5 8h-3a.5.5 0 01-.09-.992L6.5 7h3-3zm8-6h-13a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5z"
});

function SvgArchiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArchiveIcon;